module.exports = __webpack_public_path__ + "static/media/headshot2.b2dd543e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Experience/headshot2.png
// module id = 706
// module chunks = 0